import React, { useState, useEffect } from "react";
import authService from "services/auth.service";

// components
import Navbar from "components/Navbars/AuthNavbar.js";
import backgroundImages from 'assets/img/Cover_dark.webp';
import TilesSection from "components/Tiles/TilesSection";
import GeneratorSection from "components/Generator/GeneratorSection";
import AgePopup from "components/ui/AgePopup";
import TokenService from "services/token.service";

export default function Landing() {

  const [showPopup, setShowPopup] = useState(true);
  const [token, setToken] = useState(TokenService.getLocalAccessToken());

  function closePopup(adult) {
    if (adult === true) {
      setShowPopup(false);
      localStorage.setItem('age', 'adult');
    } else {
      window.location.href = "https://www.google.com";
    }
  }

  useEffect(() => {
    if (localStorage.getItem('age') === 'adult') {
      setShowPopup(false);
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = showPopup ? 'hidden' : 'auto';
  }, [showPopup]);

  useEffect(() => {
    if (token) {
      authService.checkUser();
    }
  }, []);

  useEffect(() => {
    const containerId = 'blink-pay-button-container';

    function initBlinkWidget() {
      if (typeof window.BlinkPayButton !== 'undefined') {
        window.BlinkPayButton.init({
          username: 'aichyoa',
          containerId,
          themeMode: 'dark',
          language: 'en',
          defaultAmount: 1000,
          supportedCurrencies: [
            { code: 'sats', name: 'sats', isCrypto: true },
            { code: 'USD', name: 'USD', isCrypto: false }
          ],
          debug: false
        });
      } else {
        setTimeout(initBlinkWidget, 100);
      }
    }

    const script = document.createElement('script');
    script.src = 'https://blinkbitcoin.github.io/donation-button.blink.sv/js/blink-pay-button.js';
    script.async = true;
    script.onload = initBlinkWidget;
    document.body.appendChild(script);

    return () => {
      // cleanup: remove script if still present
      if (script && script.parentNode) script.parentNode.removeChild(script);
      // optionally destroy widget if BlinkPayButton exposes a destroy method
      if (window.BlinkPayButton && typeof window.BlinkPayButton.destroy === 'function') {
        try { window.BlinkPayButton.destroy(containerId); } catch (e) { }
      }
    };
  }, []);

  return (
    <>
      {showPopup ? (
        <AgePopup closePopup={closePopup} />
      ) : null}
      < Navbar transparent />
      <section>
        <div className="relative pt-16 flex content-center items-center justify-center">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${backgroundImages})`,
              backgroundSize: "cover",
              filter: "brightness(0.4)",
            }}
          ></div>
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover bg-gradient flex items-center justify-center"
          >
          </div>

          <div className="container relative mx-auto h-full flex flex-col-reverse md:flex-row justify-center items-center pb-6">
            <div className="px-4 py-24 md:py-0 ml-auto mr-auto text-center h-full flex flex-col items-center justify-center">
              <div className="relative inline-block">
                <h1
                  className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400 text-6xl md:text-7xl drop-shadow-sm"
                  tabIndex="0"
                >
                  Interactive NSFW games with AI CHYOA
                </h1>
                <p className="text-gray-200 text-xl md:text-2xl mt-6 px-6 font-light tracking-wide">
                  Play custom NSFW games with AI CHYOA. Create your own stories and explore your fantasies.
                </p>
              </div>
              <div className='flex flex-col md:flex-row gap-6 mt-10'>
                <a href="#games">
                  <button
                    type="button"
                    className="text-white bg-gradient-to-r from-pink-600 to-orange-500 hover:from-pink-500 hover:to-orange-400 focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 font-bold rounded-full text-lg px-8 py-4 text-center shadow-lg transform transition hover:scale-105 duration-300"
                  >
                    PLAY NOW
                  </button>
                </a>
                <a href="#create">
                  <button
                    type="button"
                    className="text-white bg-transparent border-2 border-white/30 hover:bg-white/10 focus:ring-4 focus:outline-none focus:ring-white/20 font-bold rounded-full text-lg px-8 py-4 text-center backdrop-blur-sm transition hover:scale-105 duration-300"
                  >
                    CREATE GAME
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <GeneratorSection />

      <section className="bg-gray-900 py-12 px-4 antialiased flex align-center justify-center">

        <a href="https://www.wizardofswipe.com" target="_blank" className="w-full max-w-4xl group">
          <div className="container w-full flex flex-col md:flex-row p-8 bg-gray-800/50 border border-gray-700 rounded-2xl shadow-xl backdrop-blur-sm hover:bg-gray-800/80 transition-all duration-300 items-center group-hover:border-pink-500/50">
            <div className="flex flex-col items-start justify-between pr-4 flex-1">
              <h5 className="mb-3 text-3xl font-bold tracking-tight text-white text-center md:text-left group-hover:text-pink-400 transition-colors">
                Want to get more matches on Tinder?
              </h5>
              <p className="mb-4 font-normal text-gray-400 text-lg text-center md:text-left">
                Let the the AI from the Wizard of Swipe manage your Tinder for you.
                <br />
                Use the code <span className="text-orange-400 font-bold">RIZZLINES</span> and get a special discount.
              </p>
            </div>
            <button type="button" className="md:ml-10 text-white flex flex-row items-center bg-gradient-to-r from-pink-600 to-orange-500 hover:from-pink-500 hover:to-orange-400 focus:ring-4 focus:outline-none focus:ring-pink-800 font-bold rounded-xl text-xl px-6 py-3 text-center shadow-lg transform transition group-hover:scale-105 duration-300">
              <img src="/wizardofswipe-nobg.png" alt="logo" className="h-10 mr-3" />
              Wizard of Swipe
            </button>
          </div>
        </a>

      </section>

      <section className="bg-gray-900 py-8 px-4 antialiased flex flex-col align-center justify-center">
        <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">
          Help keep AI CHYOA free!
        </h5>
        {/* Blink Pay Button widget */}
        <div id="blink-pay-button-container" className="flex justify-center py-6" />
      </section>

      <TilesSection />
    </>
  );
}